import { useState, type ComponentProps } from 'react';
import styled from 'styled-components';
import { Input } from './Field';

export function PasswordInput(props: ComponentProps<typeof Input>) {
  const [visible, setVisible] = useState(false);
  return (
    <Wrap>
      <Password {...props} type={visible ? 'text' : 'password'} />
      <Toggle
        type="button"
        aria-label={visible ? '비밀번호 숨기기' : '비밀번호 표시'}
        aria-pressed={visible}
        aria-controls={props.id}
        disabled={props.disabled}
        onClick={(event) => { event.preventDefault(); setVisible((value) => !value); }}
      >
        {visible ? '숨기기' : '표시'}
      </Toggle>
    </Wrap>
  );
}

const Wrap = styled.div`
  position: relative;
  min-width: 0;
`;
const Password = styled(Input)`padding-right: 72px;`;
const Toggle = styled.button`
  position: absolute;
  top: 0;
  right: 4px;
  min-height: 44px;
  height: 100%;
  min-width: 60px;
  padding: 0 10px;
  border-radius: ${({ theme }) => theme.radius.md};
  color: ${({ theme }) => theme.colors.textSecondary};
  font-size: 12px;
  font-weight: 600;
  &:hover { color: ${({ theme }) => theme.colors.primary}; }
`;
